import {useQuery} from '@tanstack/react-query';

import {getPreRegisterConsult} from '../services/getPreRegisterConsult';

export const usePreRegisterConsultQuery = (personCode: number) =>
	useQuery({
		queryKey: ['preRegisterConsult', personCode],
		queryFn: () => getPreRegisterConsult({personCode}),
		enabled: false,
	});
